<template>
  <div
    class="drag-ball"
    draggable="true"
    @click="gorouter('customerservice')"
  >
  </div>
</template>
<script>

export default {
  name: 'dragball',
  methods: {
    gorouter(name) {
      this.$router.push({"name": name})
    }
  }
}
</script>
<style>
.drag-ball {
  z-index: 999;
  position: fixed;
  width: 1rem;
  height: 1rem;
  background: url(/static/icon/service1.png);
  border-radius: 56%;
  text-align: center;
  left: 6rem;
  bottom: 3rem;
  background-size: 1rem 1rem;
}


</style>



// WEBPACK FOOTER //
// src/components/dragball.vue